module.exports = __webpack_public_path__ + "static/media/1. Aerostáticos, Esmalte, óleo y papel  sobre policarbonato, 100 x 100 cm, 2013 copy.da28c5f5.png";